import { render, staticRenderFns } from "./save-account-dialog.component.vue?vue&type=template&id=4024b628"
import script from "./save-account-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-account-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports